import React from "react";

import styles from "./CouponFormTopTabs.module.scss";

const CouponFormTopTabs = ({ steps = [], stepIcons = {}, activeStep, onStepClick }) => {
  if (!steps.length) return null;

  return (
    <nav className={styles.tabs} aria-label="Coupon form sections">
      {steps.map((step) => {
        const StepIcon = stepIcons[step.id];
        return (
          <button
            key={step.id}
            type="button"
            className={`${styles.tabItem} ${
              activeStep === step.id ? styles.tabItemActive : ""
            }`}
            onClick={() => onStepClick(step.id)}
          >
            {StepIcon && <StepIcon className={styles.tabIcon} />}
            <span>{step.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default CouponFormTopTabs;
